@let itemTemplate = props.itemTemplate?.();
@let selectedItemTemplate = props.selectedItemTemplate?.();
@let removeIconTemplate = props.removeIconTemplate?.();

<div class="formly-chips-type">
  <p-autocomplete
    #chips
    [formControl]="formControl"
    [disabled]="props.disabled"
    [required]="props.required"
    [readonly]="props.readonly"
    [typeahead]="props.typeahead || false"
    [unique]="props.unique || true"
    [dropdown]="props.dropdown"
    [placeholder]="props.placeholder"
    [panelStyleClass]="props.panelStyleClass"
    [styleClass]="props.styleClass"
    [inputStyleClass]="props.inputStyleClass"
    [multiple]="true"
    [suggestions]="(props.useSignal ? props.suggestionsSignal?.() : props.suggestionsFilter) || []"
    (onDropdownClick)="props.onDropdownClick?.(field, $event)"
    (onClear)="props.onClear?.(field, $event)"
    (onShow)="props.onShow?.(field, $event)"
    (onHide)="props.onHide?.(field, $event)"
    (onUnselect)="props.onUnselect?.(field, $event)"
    (onKeyUp)="props.onKeyUp?.(field, $event, chips)"
    (onBlur)="onInputBlur($event)"
    (completeMethod)="props.completeMethod?.(field, $event)"
    (onFocus)="props.onFocus?.(field, $event)"
    (onSelect)="props.onSelect?.(field, $event, chips)">
    @if (itemTemplate) {
      <ng-template let-item #item>
        <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: item }" />
      </ng-template>
    }

    @if (selectedItemTemplate) {
      <ng-template let-item #selecteditem>
        <ng-container [ngTemplateOutlet]="selectedItemTemplate" [ngTemplateOutletContext]="{ $implicit: item }" />
      </ng-template>
    }

    @if (removeIconTemplate) {
      <ng-template let-class="class" let-removeCallback="removeCallback" let-index="index" #removeicon>
        <ng-container
          [ngTemplateOutlet]="removeIconTemplate"
          [ngTemplateOutletContext]="{ class: class, removeCallback: removeCallback, index: index }" />
      </ng-template>
    }
  </p-autocomplete>
</div>
